import {useEffect} from 'react'

function getScrollableParent(
  node: Node | null,
  direction: 'x' | 'y' = 'y'
): HTMLElement | null {
  if (!(node instanceof HTMLElement)) {
    return null
  }

  let el: HTMLElement | null = node
  while (el && el !== document.documentElement) {
    const style = window.getComputedStyle(el)

    if (direction === 'y') {
      const {overflowY} = style
      const canScrollY =
        overflowY === 'auto' ||
        overflowY === 'scroll' ||
        overflowY === 'overlay'

      if (canScrollY && el.scrollHeight > el.clientHeight + 1) {
        return el
      }
    } else {
      const {overflowX} = style
      const canScrollX =
        overflowX === 'auto' ||
        overflowX === 'scroll' ||
        overflowX === 'overlay'

      if (canScrollX && el.scrollWidth > el.clientWidth + 1) {
        return el
      }
    }

    el = el.parentElement
  }

  return null
}

/**
 * 全局阻止 iOS 橡皮筋回弹：锁定 body 滚动，自动识别页面内可滚动容器。
 */
export const usePreventOverscroll = () => {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return undefined
    }

    const html = document.documentElement
    const {body} = document

    const prevHtmlOverflow = html.style.overflow
    const prevBodyOverflow = body.style.overflow
    const prevBodyPosition = body.style.position
    const prevBodyWidth = body.style.width
    const prevBodyHeight = body.style.height

    html.style.overflow = 'hidden'
    body.style.overflow = 'hidden'
    body.style.position = 'fixed'
    body.style.width = '100%'
    body.style.height = '100%'

    let startY = 0

    const handleTouchStart = (e: TouchEvent) => {
      startY = e.touches[0].pageY
    }

    const handleTouchMove = (e: TouchEvent) => {
      const scrollElY = getScrollableParent(e.target as Node, 'y')
      const scrollElX = getScrollableParent(e.target as Node, 'x')

      // 横向可滚动区域需放行 touchmove，否则 overflow-x 无法滑动
      if (!scrollElY && scrollElX) {
        return
      }

      if (!scrollElY) {
        e.preventDefault()
        return
      }

      const {scrollTop, scrollHeight, clientHeight} = scrollElY
      const atTop = scrollTop <= 0
      const atBottom = scrollTop + clientHeight >= scrollHeight - 1
      const deltaY = e.touches[0].pageY - startY

      if ((atTop && deltaY > 0) || (atBottom && deltaY < 0)) {
        e.preventDefault()
      }
    }

    document.addEventListener('touchstart', handleTouchStart, {passive: true})
    document.addEventListener('touchmove', handleTouchMove, {passive: false})

    return () => {
      html.style.overflow = prevHtmlOverflow
      body.style.overflow = prevBodyOverflow
      body.style.position = prevBodyPosition
      body.style.width = prevBodyWidth
      body.style.height = prevBodyHeight
      document.removeEventListener('touchstart', handleTouchStart)
      document.removeEventListener('touchmove', handleTouchMove)
    }
  }, [])
}
